import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./Emojies.module.css";
var emojieSrc = {
  10: "/assets/images/emojis/angry_emoji.svg",
  20: "/assets/images/emojis/sad_emoji.svg",
  30: "assets/images/emojis/good_emoji.svg",
  40: "/assets/images/emojis/happy_emoji.svg",
  50: "/assets/images/emojis/very_happy_emoji.svg"
};
var Emojies = function Emojies(_ref) {
  var options = _ref.options,
    setAnswer = _ref.setAnswer,
    error = _ref.error,
    setError = _ref.setError,
    mainAnswer = _ref.mainAnswer;
  var handleChange = function handleChange(e, option) {
    setAnswer(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, {
        mainAnswer: e.target.value,
        secondaryOptions: option.secondary,
        secondaryAnswer: [],
        secondaryType: option.secondary_type === 1 ? "checkbox" : "radio"
      });
    });
    setError("");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.emojisWrapper, " ").concat(error && !mainAnswer ? stl.shake : ""),
    onAnimationEnd: function onAnimationEnd(e) {
      return e.target.classList.remove(stl.shake);
    }
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("label", {
      key: option.id,
      className: stl.emoji
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "emojies",
      value: option.id,
      onChange: function onChange(e) {
        return handleChange(e, option);
      }
    }), option.emoji && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: emojieSrc[option.emoji],
      alt: option.text || "Rating emoji"
    })), /*#__PURE__*/React.createElement("span", {
      className: !option.emoji ? stl.customText : ""
    }, option.text));
  }));
};
export default Emojies;